import { Link } from '@elementary/common-ui/components';
import ChatCodeBlock from '@elementary/common-ui/components/AiChat/markdownRenderers/ChatCodeBlock';
import { Typography } from '@mui/material';
import { RUNTIME_CONFIGURATION_DOCS_URL } from '../constants';
import SettingsSection from '../SettingsSection';
import { Runtime } from '../types';
import { buildRuntimeConfigYaml } from '../utils';

type Props = {
  runtime: Runtime;
};

const RuntimeConfiguration = ({ runtime }: Props) => (
  <SettingsSection title="Configuration">
    <Typography variant="body1">
      Start the runtime with this configuration using Docker, Helm, or Airflow.
      Save the token to the token file, and add warehouse credentials inside
      your environment.{' '}
      <Link
        href={RUNTIME_CONFIGURATION_DOCS_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Setup guide
      </Link>
    </Typography>
    <ChatCodeBlock value={buildRuntimeConfigYaml(runtime)} language="yaml" />
  </SettingsSection>
);

export default RuntimeConfiguration;
